<template>
  <v-card>
    <v-row>
      <v-col cols="3">
        <base-profile-photo :isDisabled="!canEdit" :person="record.person" @refresh="save"/>
        <v-row v-if="record.person && $store.getters.getUser.superuser">
          <v-col class="pa-0 text-center">
            <base-create-user v-if="!record.person.user" :person="record.person" @refresh="$emit('refresh')"/>
            <base-notification v-else @refresh="$emit('refresh')" :user_id="record.person.user.id"/>
          </v-col>
        </v-row>
        <v-row v-if="record.person.user">
          <v-col class="pa-0 mt-3 text-center">
            <base-action-button @action="resetPassword">
              <template #prepend><PhArrowsCounterClockwise style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("reset_password") }}
            </base-action-button>
          </v-col>
        </v-row>
        <v-row v-if="record.person.user" class="mb-5">
          <v-col class="pa-0 mt-3 text-center">
            <base-action-button :delete="true" @action="deleteUser">
              <template #prepend><PhUserMinus style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("delete_account") }}
            </base-action-button>
          </v-col>
        </v-row>
        <!--<v-btn-toggle class="mt-5" v-if="page.name === 'profile'" v-model="record.language">
          <v-btn value="nl">NL</v-btn>
          <v-btn value="en">EN</v-btn>
        </v-btn-toggle>-->
      </v-col>
      <v-col>
        <v-toolbar flat color="white" density="compact">
          <v-tabs v-model="tab" slider-color="success" grow>
            <v-tab color="primary">{{ $store.getters.translate("general_info").toUpperCase() }}</v-tab>
            <v-tab color="primary">{{ $store.getters.translate("additional_information").toUpperCase() }}</v-tab>
          </v-tabs>
          <v-spacer/>
          <div class="chip-container">
            <base-action-button v-if="page.name !== 'profile' && canDelete" :delete="true" @action="archive">
              <template #prepend><PhArchive style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("delete") }}
            </base-action-button>
            <base-action-button v-if="canEdit" @action="save">
              <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("save") }}
            </base-action-button>
          </div>
        </v-toolbar>
          <v-window v-model="tab">
            <v-window-item>
              <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
                <v-text-field
                    density="default"
                    class="reg-normal text-primary"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    :disabled="!canEdit"
                    v-model="record.person.first_name"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('first_name') }}<strong>*</strong></span>
                  </template>
                </v-text-field>
                <v-text-field
                    density="default"
                    class="reg-normal text-primary mt-3"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    :disabled="!canEdit"
                    v-model="record.person.insertion"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('insertion') }}</span>
                  </template>
                </v-text-field>
                <v-text-field
                    density="default"
                    class="reg-normal text-primary mt-3"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    :disabled="!canEdit"
                    v-model="record.person.last_name"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('last_name') }}<strong>*</strong></span>
                  </template>
                </v-text-field>
                <v-text-field
                    density="default"
                    class="reg-normal text-primary mt-3"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    :disabled="!canEdit"
                    v-model="record.person.initials"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('initials') }}</span>
                  </template>
                </v-text-field>
                <template v-for="field in usual_fields">
                  <template v-if="field.name === 'job_title_id' || field.name === 'department_id' || field.name === 'access_level_id'">
                    <base-field
                        v-if="page.name !== 'profile'"
                        :isDisabled="!canEdit"
                        :key="field.name"
                        :modelValue="record[field.name]"
                        :field="field"
                        @change="usualFieldDataChanged"/>
                  </template>
                  <!--EXCLUDE NAME FIELD BECAUSE IT`S ALREADY SHOWN BEFORE AS FIRST AND LAST NAME -->
                  <template v-else-if="field.name !== 'name'">
                    <base-field
                        :isDisabled="!canEdit"
                        :key="field.name"
                        :modelValue="record.person[field.name]"
                        :field="field"
                        @change="usualFieldDataChanged"/>
                  </template>
                </template>
              </v-card>
            </v-window-item>
            <v-window-item>
              <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
                <template v-if="record.custom_fields" v-for="field in custom_fields">
                  <base-field
                      v-if="page.name === 'profile'"
                      :isDisabled="!canEdit"
                      :key="field.name"
                      :modelValue="record.person[page.model].custom_fields[field.name]"
                      :field="field"
                      @change="customFieldDataChanged"/>
                  <base-field
                      v-else
                      :isDisabled="!canEdit"
                      :key="field.name"
                      :modelValue="record.custom_fields[field.name]"
                      :field="field"
                      @change="customFieldDataChanged"/>
                </template>
                <v-text-field
                    density="default"
                    class="reg-normal text-primary mt-3"
                    base-color="border-tertiary"
                    bg-color="secondary"
                    color="primary"
                    v-if="page.name !== 'profile' && record.person.user"
                    :disabled="!canEdit"
                    v-model="record.person.user.email"
                    hide-details
                    flat
                    clearable>
                  <template #label>
                    <span class="sm-normal text-subtle">{{ $store.getters.translate('user_email') }}</span>
                  </template>
                </v-text-field>
                <base-addresses :isDisabled="!canEdit" v-model="record.person.addresses" @update="addressesChanged"/>
                <base-email-addresses :isDisabled="!canEdit" v-model="record.person.emailaddresses" @update="emailsChanged"/>
                <base-tags v-if="page.name !== 'profile' && tags_required" :modelValue="record.tags" :isDisabled="!canEdit" :modal_name="page.name" @change="tagsChanged"/>
              </v-card>
            </v-window-item>
          </v-window>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions";
import BaseTags from "./BaseTags";
import BaseCreateUser from "./BaseCreateUser";
import BaseNotification from "./BaseNotification";
import BaseProfilePhoto from "./BaseProfilePhoto";
import BaseAddresses from "../../components/commonComponents/BaseAddresses";
import BaseEmailAddresses from "./BaseEmailAddresses";
import BaseLogField from "./BaseLogField";
import BaseActionButton from "./BaseActionButton";
import {PhArchive, PhArrowsCounterClockwise, PhFloppyDisk, PhUserMinus} from "@phosphor-icons/vue";

export default {
  name: "BaseProfile",
  props: ["page", "record"],
  components: {
    BaseTags,
    BaseCreateUser,
    BaseNotification,
    BaseProfilePhoto,
    BaseAddresses,
    BaseEmailAddresses,
    BaseLogField,
    BaseActionButton,
    PhUserMinus, PhArrowsCounterClockwise, PhFloppyDisk, PhArchive,
  },
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  data() {
    return {
      tab: 0,
      usual_fields: [],
      custom_fields: [],
      tags_required: false,
    };
  },
  mounted() {
    this.getFields();
  },
  methods: {
    async save() {
      let error = false;
      if (this.record.person.first_name === '' || this.record.person.last_name === '') {
        this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate('name'));
        error = true;
      }
      this.usual_fields.forEach((field) => {
        if (field.mandatory && field.field_type !== 'boolean' && field.name !== 'job_title_id' && field.name !== 'department_id' && field.name !== 'access_level_id' && field.name !== 'name') {
          if(!this.record.person[field.name] || this.record.person[field.name] === '') {
            this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate(field.name));
            error = true;
          }
        }
      });
      if(!error) {
        if(await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
          this.$emit('refresh');
        }
      }
    },
    async archive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, this.record.id);
          await this.$router.push("/" + this.page.name);
        }
      });
    },
    async resetPassword() {
      await helpFunctions.postCustomRoute(this.$toast, "resetpassword", { email: this.record.person.user.email }, true, true);
      this.$emit('refresh');
    },
    async deleteUser() {
      this.record.person.delete_user = true;
      await helpFunctions.patchCustomRoute(this.$toast, "people/" + this.record.person.id, this.record.person, true);
      this.$emit('refresh');
    },
    usualFieldDataChanged(data) {
      if(data[0] === 'job_title_id' || data[0] === 'department_id' || data[0] === 'access_level_id') {
        this.record[data[0]] = data[1];
      }
      else {
        this.record.person[data[0]] = data[1];
      }
    },
    emailsChanged(updated_emails) {
      this.record.person.emailaddresses = updated_emails;
      this.save();
    },
    addressesChanged(updated_addresses) {
      this.record.person.addresses = updated_addresses;
    },
    tagsChanged(data) {
      this.record.tags = data;
    },
    customFieldDataChanged(data) {
      if(this.page.name === 'profile') {
        this.record.person[this.page.model].custom_fields[data[0]] = data[1];
      }
      else {
        this.record.custom_fields[data[0]] = data[1];
      }
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_update");
      this.tags_required = response.tags_required;
      this.usual_fields = response.usual_fields;
      this.custom_fields = response.custom_fields;
    },
  },
  computed: {
    canEdit() {
      if (this.page.name === 'profile') {
        return true;
      }
      else {
        return this.can("edit", this.$createEntity(this.page.model, {id: 0})) ||
            this.can("edit", this.$createEntity(this.page.model, {id: this.record.id}));
      }
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model, { id: 0 })) ||
          this.can("delete", this.$createEntity(this.page.model, { id: this.record.id }));
    },
  },
};
</script>

<style scoped>
.chip-container {
display: flex;
gap: 8px;
margin-right: 16px;
}
</style>